
<template>
  <div class="dropdown">
    <a class="item" v-for="(item, i) in items" :key="i" @click="onSelect(item)">
      <color-circle :color="item.color" :color2="item.color2" v-if="!hideColor"/> {{ item.text }}
    </a>
  </div>
</template>

<script>
import ColorCircle from './ColorCircle';

export default {
  components: {
    ColorCircle,
  },
  name: 'color-dropdown',
  props: {
    items: Array,
    hideColor: Boolean,
    onSelect: Function,
  },
};
</script>
